import { useEffect } from 'react';
import moment from 'moment';

import useForm from '../../../hooks/useForm';
import { Grid, Typography, MenuItem, Button, Box } from '@mui/material';
import StyledModal from '../StyledModal';
import { Button as StyledButton, TextField } from '../../common';
import colors from '../../../assets/colors';
import { admin } from '../../../utils/api';
import { voivodeships } from '../../../assets/consts';

export default function ManageAccountModal(props) {
  const { handleChange, setFieldValues, values } = useForm({
    name: '',
    surname: '',
    email: '',
    department: '',
    permissionLevel: '',
    status: '',
    registrationDate: '',
    lastLoginDate: '',
  });
  const handleClose = () => {
    props.setOpen(false);
    props.setCurrentlySelected(0);
  };

  const setData = (data) => {
    setFieldValues({
      name: props.data[props.currentlySelected]?.name,
      surname: props.data[props.currentlySelected]?.surname,
      email: props.data[props.currentlySelected]?.email,
      department: props.data[props.currentlySelected]?.department,
      permissionLevel: props.data[props.currentlySelected]?.permissionLevel,
      status: props.data[props.currentlySelected]?.status,
      registrationDate: props.data[props.currentlySelected]?.registrationDate,
      lastLoginDate: props.data[props.currentlySelected]?.lastLoginDate,
    });
  };

  useEffect(() => {
    setData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setData();
    //eslint-disable-next-line
  }, [props.currentlySelected]);

  const increaseSelected = () => {
    if (props.currentlySelected + 1 < props.selected.length)
      props.setCurrentlySelected((prev) => prev + 1);
  };

  const decreaseSelected = () => {
    if (props.currentlySelected - 1 >= 0)
      props.setCurrentlySelected((prev) => prev - 1);
  };

  const handleEditAccount = async () => {
    const body = {
      department: values.department,
      ...(props.data[props.currentlySelected]?.email === values.email
        ? {}
        : { email: values.email }),
      name: values.name,
      permissions: values.permissionLevel,
      status: values.status,
      surname: values.surname,
    };
    admin
      .editUser(props.data[props.currentlySelected].id, body)
      .then((result) => {
        props.update();
        handleClose();
      })
      .catch((err) => {});
  };

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
            Zarządzaj kontem
          </Typography>
          {props.selected?.length > 1 && (
            <Button variant="contained" sx={{ ml: 2 }}>
              {props.currentlySelected + 1 + ' z ' + props.selected.length}
            </Button>
          )}
        </Grid>
        <Grid container direction={'column'}>
          <Grid container justifyContent="left">
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modal
                label="Imię"
                onChange={handleChange('name')}
                inputProps={{ 'data-testid': 'manage-name' }}
                value={values.name}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modalRight
                label="Nazwisko"
                onChange={handleChange('surname')}
                value={values.surname}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="left">
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modal
                label="E-mail"
                onChange={handleChange('email')}
                value={values.email}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modalRight
                select
                label="Oddział"
                onChange={handleChange('department')}
                value={values.department}
              >
                {voivodeships.map((v) => (
                  <MenuItem value={v}>{v}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <Grid container justifyContent="left">
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <Box
                sx={{
                  border: 1.5,
                  borderColor: colors.agroweGreen,
                  borderRadius: 1,
                  py: 1,
                  px: 2,
                  mb: 2,
                  width: '95%',
                  color: colors.agroweGreen,
                }}
              >
                <Typography sx={{ fontWeight: 600 }}>
                  DATA REJESTRACJI
                </Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {moment(new Date(values.registrationDate)).format(
                    'DD-MM-YYYY'
                  )}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <Box
                sx={{
                  border: 1.5,
                  borderColor: colors.agroweGreen,
                  borderRadius: 1,
                  py: 1,
                  px: 2,
                  mb: 2,
                  width: '95%',
                  color: colors.agroweGreen,
                }}
              >
                <Typography sx={{ fontWeight: 600 }}>
                  OSTATNIE LOGOWANIE
                </Typography>
                <Typography sx={{ fontWeight: 600 }}>
                  {values.lastLoginDate
                    ? moment(new Date(values.lastLoginDate)).format(
                        'DD-MM-YYYY hh:mm'
                      )
                    : '-'}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid container justifyContent="left">
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modal
                select
                label="Status konta"
                onChange={handleChange('status')}
                value={values.status}
              >
                <MenuItem value="true">Tak</MenuItem>
                <MenuItem value="false">Nie</MenuItem>
              </TextField>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modalRight
                select
                label="Poziom uprawnień"
                onChange={handleChange('permissionLevel')}
                value={values.permissionLevel}
              >
                <MenuItem value="bankowiec">Bankowiec</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
            <StyledButton
              red
              variant="outlined"
              onClick={props.handleDelete}
              sx={{ mr: 2 }}
            >
              USUŃ KONTO
            </StyledButton>
            {props.selected?.length > 1 && (
              <>
                <Button variant="outlined" onClick={decreaseSelected}>
                  POPRZEDNI
                </Button>
                <Button variant="contained">
                  {props.currentlySelected + 1 + ' z ' + props.selected.length}
                </Button>
                <Button variant="outlined" onClick={increaseSelected}>
                  NASTĘPNY
                </Button>
              </>
            )}

            <Button variant="outlined" onClick={handleEditAccount}>
              ZAPISZ ZMIANY
            </Button>
          </Grid>
        </Grid>
      </StyledModal>
    </>
  );
}
